export function openModal(className = '') {
    const modal = document.querySelector('.simple-modal' + className);
    modal.classList.add('open');
}

export function closeModal(className = '') {
    const modal = document.querySelector('.simple-modal' + className);
    modal.classList.remove('open');
}
